import Section from '../Section'
import waveIcon from './wave.svg'
import craneIcon from './crane.svg'
import houseIcon from './house.svg'
import calendarIcon from './calendar.svg'
import { defineMessages, useIntl } from 'react-intl'
import { ThingsToNoteItem } from './ThingsToNoteItem'
import { ListingDetailsListing } from '../../../../types/listings'
import { DataProvidedByMlsAbbrevAndNumber } from '../../Compliance/DataProvidedByMlsAbbrevAndNumber'

import styles from './ThingsToNote.module.scss'

export const MSG = defineMessages({
  header: {
    id: 'HomeSearch.listingDetails.thingsToNote',
    defaultMessage: 'Things To Note',
  },
  calendarAlt: {
    id: 'ListingDetails.ThingsToNote.calendarAlt',
    defaultMessage: 'Calendar icon',
  },
  builtIn: {
    id: 'ListingDetails.ThingsToNote.builtIn',
    defaultMessage: 'Built in {year}',
  },
  houseAlt: {
    id: 'ListingDetails.ThingsToNote.houseAlt',
    defaultMessage: 'House icon',
  },
  waveAlt: {
    id: 'ListingDetails.ThingsToNote.waveAlt',
    defaultMessage: 'Wave icon',
  },
  waterfront: {
    id: 'ListingDetails.ThingsToNote.waterfront',
    defaultMessage: 'Waterfront',
  },
  craneAlt: {
    id: 'ListingDetails.ThingsToNote.craneAlt',
    defaultMessage: 'Crane icon',
  },
  newConstruction: {
    id: 'ListingDetails.ThingsToNote.newConstruction',
    defaultMessage: 'New Construction',
  },
})

export interface ThingsToNoteProps {
  className?: string
  listing: ListingDetailsListing
}

export const ThingsToNote = ({ listing, className }: ThingsToNoteProps) => {
  const intl = useIntl()

  return (
    <Section className={className}>
      <Section.Heading>{intl.formatMessage(MSG.header)}</Section.Heading>
      <Section.Body>
        <div className={styles.thingsToNote}>
          {!!listing.yearBuilt && (
            <ThingsToNoteItem
              img={calendarIcon}
              alt={intl.formatMessage(MSG.calendarAlt)}
              note={intl.formatMessage(MSG.builtIn, {
                year: listing.yearBuilt,
              })}
            />
          )}
          <ThingsToNoteItem
            img={houseIcon}
            note={listing.propertyType}
            alt={intl.formatMessage(MSG.houseAlt)}
          />
          {listing.is?.isWaterfront && (
            <ThingsToNoteItem
              img={waveIcon}
              alt={intl.formatMessage(MSG.waveAlt)}
              note={intl.formatMessage(MSG.waterfront)}
            />
          )}
          {listing.is?.isNewConstruction && (
            <ThingsToNoteItem
              img={craneIcon}
              alt={intl.formatMessage(MSG.craneAlt)}
              note={intl.formatMessage(MSG.newConstruction)}
            />
          )}
        </div>
        <div className={styles.sectionFooter}>
          <DataProvidedByMlsAbbrevAndNumber
            listing={listing}
            className={styles.dataProvidedBy}
          />
        </div>
      </Section.Body>
    </Section>
  )
}
